import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-date-time-picker";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
class ConfigurationItemInstallationTab {
    Bao = Bao;
    InstalledDate = ko.observable();
    InstalledDateJS = ko.observable();
    DeliveredTo = ko.observable();
    WarrantyUtilJS = ko.observable();
    DischargedDateJS = ko.observable();
    LeavingTo = ko.observable();
    LeavingToDateJS = ko.observable();
    RevisionSafeDeleted = ko.observable();
    InstalledByUserId = ko.observable();
    InstalledByUserName = ko.observable();
    CheckedByUserId = ko.observable();
    CheckedByUserName = ko.observable();
    DeliveredByUserId = ko.observable();
    DeliveredByUserName = ko.observable();
    WarrantyTypeId = ko.observable();
    WarrantyTypeName = ko.observable();
    Loading = ko.observable<boolean>(false);
    constructor(public TabPage: TabPage, public Parent) {
        this.TabPage.DirtyFlag.subscribe((isDirty) => {
            if (isDirty) {
                this.Parent.TabPage.DirtyFlag(true);
            }
        });
    }
    CompleteCheck() {
        var def = $.Deferred();
        def.resolve(true);
        return def.promise();
    }
    Refresh() {
        this.Loading(true);
        this.TabPage.IsLoading(true);
        return Bao.post("ConfigurationItemInstallationTab/Get", JSON.stringify({
            id: this.Parent.ConfigurationItemId(),
        }), (result) => {
            if (result != null) {
                ko.map.fromJS(result, this, this.TabPage.DirtyFlag);
            }
            this.Loading(false);
            this.TabPage.IsLoading(false);
        });
    }
    Save(saveTime) {
        this.Loading(true);
        this.TabPage.IsLoading(true);
        return Bao.post("ConfigurationItemInstallationTab/Save", JSON.stringify({
            saveTime: saveTime,
            model: ko.map.toJS(this)
        }), (result) => {
            this.Loading(false);
            this.TabPage.DirtyFlag(false);
            this.TabPage.IsLoading(false);
        });
    }
    init() {
    }
    loaded() {
        return this.Refresh();
    }
    ;
}
export default ConfigurationItemInstallationTab;